// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"156":"44a04f25","232":"f8533c98"}[chunkId] + ".chunk.js";
};